import gql from 'graphql-tag';

export const inviteDwellersUrl = gql`
  query inviteDwellersUrl($condominiumContextId: ID!) {
    inviteDwellersUrl(condominiumContextId: $condominiumContextId)
  }
`;
